import React, { KeyboardEvent } from 'react';
import { getHasOffersGroup } from 'redux/modules/search-and-browse/selectors/get-filter-groups';
import { useWtrSelector } from 'redux/hooks';
import { Toggle } from '@johnlewispartnership/wtr-ingredients/ingredients/Toggle';
import type { Group, Value } from 'components/Search/Filters/types';
import classNames from 'classnames';

import { yieldToMain } from 'utils/yield-to-main';
import styles from './OffersToggle.scss';

interface OffersToggleProps {
  disabled: boolean;
  forceRender?: boolean;
  onChange: (group: Group, value: Value) => void;
}

const OfferToggle = ({ disabled, forceRender = false, onChange }: OffersToggleProps) => {
  const offerGroup = useWtrSelector(getHasOffersGroup);
  if (!offerGroup && !forceRender) return null;

  const handleChange = async () => {
    await yieldToMain();
    onChange(
      {
        name: 'OFFER_TYPE',
        allowMultiple: true,
        label: '',
        options: [],
        value: '',
      },
      'promotionflag',
    );
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleChange();
    }
  };

  return (
    <article className={styles.offerControlWrapper}>
      <label
        className={classNames(styles.offerText, {
          [styles.disabled]: disabled,
        })}
        htmlFor="offers-toggle"
      >
        Only offers
      </label>
      <Toggle
        id="offers-toggle"
        checked={forceRender ? true : offerGroup.applied}
        disabled={disabled}
        data-testid="offers_toggle"
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        showHide={false}
      />
    </article>
  );
};

export default OfferToggle;
